import React, { Component } from "react"
import { trackTravelPlanner } from "../../helpers/tracking"
import * as cookieHelper from "../../helpers/cookie"

export default class TimaticWidget extends Component {
  componentDidMount() {
    const script = document.createElement("script")
    script.id = "timatic-widget"
    script.src = "https://widget.timatic.iata.org/scripts/iata-timatic-widget-live.js"
    document.body.appendChild(script)

    let intervalId = setInterval(this.intervalCheckWidgetLoaded, 100, this)
    this.setState({ intervalId: intervalId })
  }

  render() {
    return <div id="iata-timatic-widget"></div>
  }

  updateWidget(button, flightId) {
    console.debug("updating timatic widget")

    // timeout as the widget does not use timaticWidgetInputData unless set after the widget is fully loaded
    setTimeout(() => {
      const urlParams = new URLSearchParams(window.location.search)
      const dep = urlParams.get("dep")
      const dest = urlParams.get("dest")
      if (dep) {
        window.timaticWidgetInputData.selectedDepartureAirportCode = dep
      }
      if (dest) {
        window.timaticWidgetInputData.selectedDestinationAirportCode = dest
      }
    }, 1000)

    // Add tracking
    if (button) {
      button.addEventListener(
        "click",
        function () {
          let source = document.getElementById("search-field-2")
          let destination = document.getElementById("search-field-1")
          let nationality = document.getElementById("search-field-3")
          let residency = document.getElementById("search-field-4")

          if (source && destination) {
            const data = {
              event: "timatic-submit",
              eventCategory: "timatic",
              eventAction: "submit",
              eventLabel: "timatic submit",
              eventValue: 0,
              eventNoninteraction: true,
              departure: source.value,
              destination: destination.value,
              nationality: nationality.value,
              residency: residency.value,
              pageBusinessunit: "timatic",
              logged_in: cookieHelper.isLoggedIn(),
            }
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(data)
          }

          // tp tracking
          if (flightId) {
            trackTravelPlanner("track-event.generic", "covid-19 - submit", "", flightId)
          }
        },
        false,
      )
    }
  }

  intervalCheckWidgetLoaded(self) {
    let widgetButton = document.getElementsByClassName("iata-widget-button")
    if (widgetButton && widgetButton.length > 0 && self.state) {
      clearInterval(self.state.intervalId)
      self.updateWidget(widgetButton[0], self.props.flightInfo?.FlightId ?? null)
    }
  }
}
